import React from 'react'
import styles from './confirmationControls.module.scss'
import BtnSecondary from '../BtnSecondary'
import BtnPrimary from '../BtnPrimary'
import { useTranslation } from 'react-i18next'

type BtnConfig = {
  text?: string
  onClick: () => void
  disabled?: boolean
}
interface Props {
  confirmBtn: BtnConfig
  cancelBtn: BtnConfig
}

const ConfirmationControls = ({ confirmBtn, cancelBtn }: Props) => {
  const { t } = useTranslation(['strCommonUI'])

  return (
    <div className={styles.btnsContainer}>
      <BtnSecondary
        onClick={cancelBtn.onClick}
        size='small'
        className={styles.btn}
        isDisabled={cancelBtn.disabled}
      >
        {cancelBtn.text ?? t('button.cancel')}
      </BtnSecondary>
      <BtnPrimary
        onClick={confirmBtn.onClick}
        size='small'
        className={styles.btn}
        isDisabled={confirmBtn.disabled}
      >
        {confirmBtn.text ?? t('button.confirm')}
      </BtnPrimary>
    </div>
  )
}

export default ConfirmationControls
